import * as React from 'react';
import {useCallback} from 'react';

export interface UseInteractiveLegends {
    hoveredKey: string | undefined;
    hiddenKeys: string[];

    onLegendClick: (key: string) => void;
    onLegendMouseEnter: (key: string) => void;
    onLegendMouseLeave: () => void;
    setHiddenKeys: (keys: string[]) => void;
}

const useInteractiveLegends = (): UseInteractiveLegends => {
    const [hoveredKey, setHoveredKey] = React.useState<string | undefined>();
    const [hiddenKeys, setHiddenKeys] = React.useState<string[]>([]);

    const onLegendClick = useCallback(
        (key: string) => {
            setHiddenKeys(hidden =>
                hidden.includes(key) ? hidden.filter(k => k !== key) : [...hidden, key]
            );
        },
        [setHiddenKeys]
    );

    const onLegendMouseEnter = useCallback(
        (key: string) => {
            setHoveredKey(key);
        },
        [setHoveredKey]
    );

    const onLegendMouseLeave = useCallback(() => {
        setHoveredKey(undefined);
    }, [setHoveredKey]);

    return {
        hoveredKey,
        hiddenKeys,
        onLegendClick,
        onLegendMouseEnter,
        onLegendMouseLeave,
        setHiddenKeys
    };
};

export default useInteractiveLegends;
